import React from "react";
import { Circle, CircleMarker, Popup } from "react-leaflet";
import { useSavedLocations } from "../../lib/SavedLocationsContext";

const MI_TO_METERS = 1609.344;
const RING_STYLE = {
  color: "#F2542D",
  weight: 1,
  opacity: 0.45,
  fillColor: "#F2542D",
  fillOpacity: 0.04,
  dashArray: "4 4",
};
const MARKER_STYLE = {
  color: "#fff",
  weight: 2,
  fillColor: "#F2542D",
  fillOpacity: 1,
};

export default function SavedLocationsLayer({ locations }) {
  const { remove } = useSavedLocations();
  return locations.map((loc) => (
    <React.Fragment key={`loc-${loc.id}`}>
      <Circle
        center={[loc.lat, loc.lon]}
        radius={loc.radius_mi * MI_TO_METERS}
        pathOptions={RING_STYLE}
      />
      <CircleMarker center={[loc.lat, loc.lon]} radius={6} pathOptions={MARKER_STYLE}>
        <Popup>
          <div>
            <div className="text-[10px] font-bold uppercase tracking-wider text-tac-primary">Saved Location</div>
            <div className="font-display font-bold text-sm text-tac-text">{loc.label}</div>
            <div className="text-[15px] font-mono-tac text-tac-dim">
              {loc.radius_mi} mi alert radius
            </div>
            <button
              type="button"
              data-testid={`remove-pin-${loc.id}`}
              onClick={() => remove(loc.id)}
              style={{
                marginTop: 8,
                padding: "3px 10px",
                fontSize: 10,
                fontWeight: 700,
                textTransform: "uppercase",
                letterSpacing: "0.08em",
                color: "#E63946",
                background: "transparent",
                border: "1px solid #E63946",
                borderRadius: 2,
                cursor: "pointer",
              }}
            >
              Remove pin
            </button>
          </div>
        </Popup>
      </CircleMarker>
    </React.Fragment>
  ));
}
